import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Push } from '../model/push';
import { Rodada } from '../model/rodada';
import { StatusRodadaEnum } from '../model/enum/status-rodada.enum';
import { ListaPaginada } from '../model/lista-paginada';
import { InvestidorAssessorado } from '../model/investidor-assessorado';
import { RespostaHttp } from '../model/resposta-http';
import { RodadasCoreService } from './rodadas-core.service';
import { AssessorCoreService } from './assessor-core.service';

@Injectable({
  providedIn: 'root'
})
export class PushCoreService{

  constructor(
    private http: HttpClient,
    private rodadaCoreService: RodadasCoreService,
    private assessorCoreService: AssessorCoreService
  ){ }

  postPush(push: Push, assessorUuid: string): Observable<Rodada> {
    return this.http.post<Rodada>(
      `${environment.apiUrl}/assessores/${assessorUuid}/push`, push, {headers:{intercept: "true"}}
    ).pipe(take(1));
  }

  getRodadasPush(): Observable<RespostaHttp<ListaPaginada<Rodada>>> {
    return this.rodadaCoreService.getRodadasPorStatus(StatusRodadaEnum.ON, {tamanhoPagina: 100});
  }

  getInvestidoresPush(assessorUuid: string): Observable<RespostaHttp<ListaPaginada<InvestidorAssessorado>>> {
    return this.assessorCoreService.getInvestidoresPush(assessorUuid, {tamanhoPagina: 100});
  }
}
